<script setup lang="ts">
import MessageTemplatesPage from '../features/message-templates/MessageTemplatesPage.vue';
</script>

<template>
  <MessageTemplatesPage />
</template>
